// extracted by mini-css-extract-plugin
export default {"box":"refundFilterPage_box__5hnAY","box__content":"refundFilterPage_box__content__YSxd0"};